<prlw-mobile-manage-overlay-ui
  [items]="columns$ | async"
  (eventClose)="eventClose.emit()"
  (eventMobileListSectionItemClick)="handleMobileListSectionItemClick($event)"
  (eventUpdateItemsInArray)="handleUpdateItemsInArray($event)"
>
</prlw-mobile-manage-overlay-ui>
